import React, { Suspense } from "react";
import { useOutlet } from "react-router-dom";
import Spinner from "components/common/spinner/Spinner";
import "./AnonymousUserLayout.scss";
import { usePromiseTracker } from "react-promise-tracker";

const AnonymousUserLayout = () => {
  const { promiseInProgress } = usePromiseTracker();
  const outlet = useOutlet();

  return (
    <Suspense fallback={<Spinner />}>
      <div className="full-screen">
        {promiseInProgress && <Spinner />}
        {outlet}
      </div>
    </Suspense>
  );
};

export default AnonymousUserLayout;
